export const tipoCondominio = [
    {
        value: 1,
        descricao: 'Remoto'
    },
    {
        value: 2,
        descricao: 'Híbrido'
    },
    {
        value: 3,
        descricao: 'Local'
    },
    {
        value: 4,
        descricao: 'Autônomo'
    }
]

export const nivelUsuario = [
    {
        nivel: 1,
        descricao: '1 - Administrador'
    },
    {
        nivel: 2,
        descricao: '2 - Gerente'
    },
    {
        nivel: 3,
        descricao: '3 - Operador'
    },
    {
        nivel: 5,
        descricao: '5 - Dashboard'
    },
    {
        nivel: 6,
        descricao: '6 - Controle de Transporte'
    },
    {
        nivel: 7,
        descricao: '7 - Técnico'
    }
]

export const diasHorarioHibrido = [
    {
        value: 0,
        descricao: 'Feriado'
    },
    {
        value: 1,
        descricao: 'Domingo'
    },
    {
        value: 2,
        descricao: 'Segunda'
    },
    {
        value: 3,
        descricao: 'Terça'
    },
    {
        value: 4,
        descricao: 'Quarta'
    },
    {
        value: 5,
        descricao: 'Quinta'
    },
    {
        value: 6,
        descricao: 'Sexta'
    },
    {
        value: 7,
        descricao: 'Sábado'
    }
]

export const tiposOcorrencias = [
    {
        id: 1,
        descricao: 'Observação'
    },
    {
        id: 2,
        descricao: 'Ocorrência'
    }
]

export const tiposOrdemServico = {
    tipos: [
        {
            id: 1,
            descricao: 'Corretiva'
        },
        {
            id: 2,
            descricao: 'Instalação'
        },
        {
            id: 3,
            descricao: 'Preventiva'
        }
    ],
    getOne: (id) => {
        return { ...tiposOrdemServico.tipos[id - 1] }
    },
    getAll: (statusCancelado = true) => {
        return [...tiposOrdemServico.tipos]
    }
}

export const tiposBusquedaEquipe = [
    {
        id: 1,
        descricao: 'Equipe'
    },
    {
        id: 2,
        descricao: 'Condominio'
    },
    {
        id: 3,
        descricao: 'Evento'
    }
]

export const statusOrdemServico = {
    status: [
        {
            id: 1,
            descricao: 'Aberto'
        },
        {
            id: 2,
            descricao: 'Andamento'
        },
        {
            id: 3,
            descricao: 'Fechado'
        },
        {
            id: 4,
            descricao: 'Cancelado'
        }
    ],
    getOne: (id) => {
        return { ...statusOrdemServico.status[id - 1] }
    },
    getDescricaoStatus: (id) => {
        return statusOrdemServico.getOne(id).descricao
    },
    getAll: (statusCancelado = true) => {
        return [...statusOrdemServico.status]
    },
    getAllSemCancelado: () => {
        let status = statusOrdemServico.getAll()
        status.splice(3, 1)
        return status
    }
}

export const getAudios = () => {
    const audios = require.context('../Assets/Audios/sonsEventos', false, /\.(mp3|wav)$/)
    const audiosArray = []
    audios.keys().forEach((key) => {
        const nomeArquivo = key.replace('./', '')
        const nomeArquivoSemExtensao = nomeArquivo.replace('.mp3', '').replace('.wav', '')
        audiosArray.push({
            id: nomeArquivo,
            descricao: nomeArquivoSemExtensao
        })
    })
    return audiosArray
}

export const audiosEvento = getAudios()

export const tempoDesligar = [
    { id: 0, descricao: 'Selecione' },
    { id: 3, descricao: '3 minuto' },
    { id: 5, descricao: '5 minutos' },
    { id: 10, descricao: '10 minutos' },
    { id: 15, descricao: '15 minutos' },
    { id: 30, descricao: '30 minutos' },
    { id: 45, descricao: '45 minutos' },
    { id: 60, descricao: '1 hora' },
    { id: 90, descricao: '1 Hora e 30 Minutos' },
    { id: 120, descricao: '2 horas' },
    { id: 180, descricao: '3 horas' },
    { id: 240, descricao: '4 horas' },
    { id: 300, descricao: '5 horas' },
    { id: 360, descricao: '6 horas' },
    { id: 480, descricao: '8 horas' },
    { id: 720, descricao: '12 horas' }
]
